export function calculateAge(birthday, asOf = new Date()) {
  const birthDate = new Date(birthday)
  if (Number.isNaN(birthDate.getTime())) return null

  let age = asOf.getFullYear() - birthDate.getFullYear()
  const hasHadBirthdayThisYear =
    asOf.getMonth() > birthDate.getMonth() ||
    (asOf.getMonth() === birthDate.getMonth() && asOf.getDate() >= birthDate.getDate())

  if (!hasHadBirthdayThisYear) age -= 1

  return age
}
